import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useCollegeContext } from '../../contexts/CollegeContext';
import GlobalCollegeView from './GlobalCollegeView';

const CollegeRouter = () => {
  const { collegeId: id } = useParams();
  const navigate = useNavigate();
  const { colleges } = useCollegeContext();
  const [isNavigating, setIsNavigating] = useState(false);

  console.log('🔍 CollegeRouter debug:', {
    id,
    hasColleges: !!colleges,
    collegesCount: colleges?.length || 0,
    collegeIds: colleges?.map(c => c.id) || [],
    pathname: window.location.pathname
  });

  // Determine if this is a student college or global college
  const studentCollege = colleges.find(college => college.id === id);
  
  console.log('🔍 CollegeRouter college lookup:', {
    id,
    foundStudentCollege: !!studentCollege,
    studentCollegeName: studentCollege?.name
  });
  
  // Handle navigation in useEffect to avoid React warning
  useEffect(() => {
    if (studentCollege && !isNavigating) {
      console.log('🔄 CollegeRouter: Navigating to enhanced strategy for:', studentCollege.name);
      setIsNavigating(true);
      // This is a student's college - navigate to the properly wrapped enhanced strategy route
      // Use replace to avoid creating extra history entries
      navigate(`/college/colleges/${id}`, { replace: true });
    }
  }, [studentCollege, id, navigate, isNavigating]);
  
  if (studentCollege) {
    // Show loading while navigating
    return (
      <div className="min-h-screen bg-stone-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-slate-900 mx-auto"></div>
          <p className="mt-4 text-stone-600">Loading college strategy...</p>
        </div>
      </div>
    );
  } else {
    console.log('🌐 CollegeRouter: Showing global college view for ID:', id);
    // This is a global college - show the read-only global view
    return <GlobalCollegeView globalCollegeId={id} />;
  }
};

export default CollegeRouter;